import { validateAuthResponse, authorizationCodeGrantRequest, processAuthorizationCodeResponse, getValidatedIdTokenClaims, } from 'oauth4webapi';
import { assertIsNotOAuth2Error } from './assertIsNotOAuth2Error';
import { buildClientConfig } from './buildClientConfig';
export const processCodeRedirectCallback = async ({ clientCredentials, authorizationServer, urlWithCallbackResult, expectedState, originalRedirectUrl, codeVerifier, }) => {
    const client = buildClientConfig(clientCredentials);
    const codeGrantParams = validateAuthResponse(authorizationServer, client, urlWithCallbackResult, expectedState);
    assertIsNotOAuth2Error(codeGrantParams);
    const clientAuth = (_, clientAuthClient, __, headers) => {
        const credentials = `${clientAuthClient.client_id}:${clientAuthClient.client_secret}`;
        const encoded = btoa(credentials);
        headers.set('Authorization', `Basic ${encoded}`);
    };
    const response = await authorizationCodeGrantRequest(authorizationServer, client, clientAuth, codeGrantParams, originalRedirectUrl.href, codeVerifier);
    const result = await processAuthorizationCodeResponse(authorizationServer, client, response);
    assertIsNotOAuth2Error(result);
    const idTokenClaims = getValidatedIdTokenClaims(result);
    return {
        ...result,
        idTokenClaims,
    };
};
